import { fetchApi } from '@/app/api';
import {
  DTO,
  Workorder,
  WorkorderLabor,
  WorkorderLaborWithContext,
  parseWorkorderLaborDto,
} from '@certhon/models';
import { map } from 'remeda';

/** PostgREST response shape for labor with embedded workorder subset */
type WorkorderLaborEmbeddedResponse = DTO<WorkorderLabor> & {
  workorder: Pick<
    DTO<Workorder>,
    'id' | 'description' | 'customer_name' | 'completed'
  >;
};

/**
 * Fetch labor entries for a user within a date range, with workorder context.
 * Uses PostgREST resource embedding via computed relationship function.
 */
export async function fetchMyWeekLabor(
  userId: number,
  weekStart: string, // ISO date: "2024-11-25"
  weekEnd: string, // ISO date: "2024-12-02"
): Promise<WorkorderLaborWithContext[]> {
  const labor = await fetchApi('/workorder_labor', {
    user_id: `eq.${userId}`,
    date_start: `gte.${weekStart}`,
    and: `(date_start.lt.${weekEnd})`,
    select: '*,workorder(id,description,customer_name,completed)',
    order: 'date_start.asc',
  });

  return map(labor as WorkorderLaborEmbeddedResponse[], (dto) => ({
    ...parseWorkorderLaborDto(dto),
    workorder: dto.workorder, // already the right shape, no dates to parse
  }));
}
